import * as React from 'react';
import { SVGProps } from 'react';

const IconBookStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 3a1 1 0 0 1 1 1v16l-.005.102a1 1 0 0 1-.893.893L17 21H6l-.103-.005a1 1 0 0 1-.892-.893L5 20V4a1 1 0 0 1 1-1h11ZM7 19h9v-1H9a1 1 0 1 1 0-2h7V5h-5v7l-1.5-1L8 12V5H7v14Z"
    />
  </svg>
);
export default IconBookStrokedSizeM;
